export default __webpack_public_path__ + "static/media/footer-alt.68654f91.png";